import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getCompanyLogo = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/files/companyLogo`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCompanyConfig = async (dispatch: Dispatch, name: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/configuration/${name}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCompanyMultipleConfig = async (
  dispatch: Dispatch,
  names: string[],
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/configuration/${names.join(',')}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOwnEnrollmentStatus = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/ownEnrollmentStatus`,
    dispatch,
  });
  if (response) return response.data;
};

export const triggerScrapOwnBusiness = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/company/triggerScrapOwnBusiness`,
    dispatch,
  });
  if (response) return response.data;
};
